/* 「今日の一本おみくじ」（2026-10-08・Claude。査読 P1×4・P2 を反映した版）
   文言：window.W99G_I18N（assets/w99-gacha-i18n.js）。商品：#w99g-products（区画が市場の文脈で出力した飲み物だけ）。
   集めた絵札は localStorage に保存。配布URLが空ならクーポン送信なし。設定後はUID・国を配布側へ送り、コード予約・台帳記録を要求する。カート・顧客・注文は変更しない。 */
(function () {
  'use strict';
  var root = document.getElementById('w99g');
  if (!root) return;
  var stage = root.querySelector('[data-w99g-stage]');
  var I18N = window.W99G_I18N || {};
  var FORT = window.W99G_FORTUNES || {};
  var lang = root.dataset.lang || 'en';
  var T = I18N[lang] || I18N[(lang || '').split('-')[0]] || I18N.en || I18N.ja;
  if (!T) return;
  var F = FORT[lang] || FORT[(lang || '').split('-')[0]] || FORT.en || FORT.ja || null;
  var country = (root.dataset.country || '').toUpperCase();
  var age = parseInt(root.dataset.age || '20', 10);
  var alcAllowed = root.dataset.alc === 'true';
  /* 日本以外では、お酒の道でも瓶や杯の無い絵札・絵を使う（AI-CAO 点検の守り。選択そのものは全地域で出す＝井上様 2026-10-08） */
  var picAlcOk = country === 'JP';
  var euuk = root.dataset.euuk === '1';
  /* クーポン（2026-10-08 井上様：無作為・5%まで）。配布先の URL は区画の設定。無ければクーポンの表示は一切しない */
  var couponUrl = root.dataset.coupon || '';
  var couponRate = parseInt(root.dataset.couponRate || '10', 10);
  /* 配布する国。台湾・英国・香港・伊・蘭・豪州は出さない（AI-CAO ガチャ地域別点検 §4-6-17・査読 P1-3）。GAS の ALLOW と同じにする */
  var COUPON_ALLOW = 'JP KR US DE FR ES AT BE IE PT FI SE DK PL CZ LU GR HU SK SI HR RO BG EE LV LT MT CY'.split(' ');
  var UID_KEY = 'w99gacha_uid_v1';
  function uid() { try { var u = localStorage.getItem(UID_KEY); if (!u) { u = (window.crypto && crypto.randomUUID ? crypto.randomUUID() : 'u' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12)); localStorage.setItem(UID_KEY, u); } return u; } catch (e) { return 'u' + Date.now().toString(36); } }
  function couponEligible() { return !state.alc && !!couponUrl && COUPON_ALLOW.indexOf(country) >= 0; }
  function fmtDate(iso) { try { var d = new Date(iso + 'T00:00:00'); return d.toLocaleDateString(lang, { year: 'numeric', month: 'long', day: 'numeric' }); } catch (e) { return iso; } }
  function couponTerms(exp, rate) { return couponEligible() && exp ? '<p class="w99g-small">' + esc(fmt(T.coupon_terms, { p: rate != null ? rate : couponRate, expiry: exp })) + '</p>' : ''; }
  function requestCoupon(host) {
    if (!couponEligible() || !host) return;
    var box = document.createElement('section'); box.className = 'w99g-coupon'; box.setAttribute('aria-live', 'polite'); host.appendChild(box);
    fetch(couponUrl, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ uid: uid(), country: country }) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.ok || d.eligible === false) { box.remove(); return; }
        var exp = d.expiry ? fmtDate(d.expiry) : '';
        /* 条件（確率・期限）は配布側の応答で描く（表示と実際がずれないように・査読 P2-1/P2-2） */
        var terms = couponTerms(exp, d.rate);
        if (!d.win || !d.code) { box.innerHTML = terms; if (!terms) box.remove(); return; }
        box.innerHTML = '<h3>' + esc(T.coupon_head) + '</h3><p>' + esc(fmt(T.coupon_body, { expiry: exp })) + '</p>' +
          '<p class="w99g-coupon__code"><span>' + esc(T.coupon_code_label) + '</span><code>' + esc(d.code) + '</code>' +
          '<button type="button" class="w99g-btn" data-act="copycode" data-code="' + esc(d.code) + '">' + esc(T.coupon_copy) + '</button></p>' + terms;
      })
      .catch(function () { box.innerHTML = '<p class="w99g-small">' + esc(T.coupon_error) + '</p>'; });
  }
  var imgBase = root.dataset.img || '';
  var products = [];
  try { products = JSON.parse(document.getElementById('w99g-products').textContent || '[]'); } catch (e) { products = []; }

  /* 絵札16枚。alc＝瓶や杯が描かれている札（お酒の道でだけ出す） */
  var CARDS = [
    { id: 'kyuna-guide',      file: 'w99mq-kyuna-guide.webp',          r: 'n',  alc: true },
    { id: 'shuiin-guide',     file: 'w99mq-shuiin-guide.webp',         r: 'n',  alc: true },
    { id: 'cola',             file: 'w99mq-result-cola.webp',          r: 'n',  alc: false },
    { id: 'cola-2',           file: 'w99mq-result-cola-2.webp',        r: 'n',  alc: false },
    { id: 'cola-kyuna',       file: 'w99mq-alt-cola-kyuna.webp',       r: 'n',  alc: false },
    { id: 'cola-shuiin-straw', file: 'w99mq-alt-cola-shuiin-straw.webp', r: 'n', alc: false },
    { id: 'bartender',        file: 'w99mq-result-bartender.webp',     r: 'r',  alc: true },
    { id: 'wine',             file: 'w99mq-result-wine.webp',          r: 'r',  alc: true },
    { id: 'sipping',          file: 'w99mq-result-sipping.webp',       r: 'r',  alc: true },
    { id: 'karaoke',          file: 'w99mq-result-karaoke.webp',       r: 'r',  alc: false },
    { id: 'karaoke-kyuna',    file: 'w99mq-alt-karaoke-kyuna.webp',    r: 'r',  alc: false },
    { id: 'futon',            file: 'w99mq-result-futon.webp',         r: 'r',  alc: false },
    { id: 'duo',              file: 'w99mq-duo-transparent.webp',      r: 'sr', alc: true },
    { id: 'bartender-duo',    file: 'w99mq-result-bartender-duo.webp', r: 'sr', alc: true },
    { id: 'riding',           file: 'w99mq-result-riding.webp',        r: 'sr', alc: false },
    { id: 'riding-kyuna',     file: 'w99mq-alt-riding-kyuna-front.webp', r: 'sr', alc: false }
  ];
  var RATES = { n: 70, r: 25, sr: 5 };
  var STORE_KEY = 'w99gacha_cards_v1';
  var DAY_KEY = 'w99gacha_last_v1';
  /* 1日1回（AI-CAO ガチャ地域別点検 2026-10-08 §4-6：「もう1回」の圧や連続演出を作らない）。日付は端末のローカル日 */
  function today() { var d = new Date(); return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(); }
  function pulledToday() { try { return localStorage.getItem(DAY_KEY) === today(); } catch (e) { return false; } }
  function markPulled() { try { localStorage.setItem(DAY_KEY, today()); } catch (e) {} }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmt(s, o) { return String(s).replace(/\{(\w+)\}/g, function (_, k) { return o[k] != null ? o[k] : ''; }); }
  function img(name) { return imgBase + name; }
  function loadCol() { try { return JSON.parse(localStorage.getItem(STORE_KEY) || '{}') || {}; } catch (e) { return {}; } }
  function saveCol(c) { try { localStorage.setItem(STORE_KEY, JSON.stringify(c)); } catch (e) { /* 使えない環境では集めた札を残さない */ } }
  function region() {
    var EU = 'AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE CH NO IS LI'.split(' ');
    if (country === 'JP') return 'jp';
    if (country === 'TW') return 'tw';
    if (country === 'FR') return 'fr';
    if (EU.indexOf(country) >= 0) return 'eu';
    return 'other';
  }
  function alcNotice() { var r = region(); return r === 'jp' ? T.notice_jp : r === 'tw' ? T.notice_tw : r === 'fr' ? T.notice_fr : T.notice_default; }

  var state = { alc: false };
  var started = false;
  function render(html) {
    stage.innerHTML = html;
    if (!started) { started = true; return; }
    var h = stage.querySelector('h1,h2'); if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function cardPool() { return CARDS.filter(function (c) { return (state.alc && picAlcOk) || !c.alc; }); }
  /* お酒の道＝酒類＋ノンアルの全商品、ノンアルの道＝ノンアルだけ。買える（または問い合わせできる）物だけ（井上様 2026-10-08） */
  function productPool() {
    var pool = products.filter(function (p) { return state.alc ? true : !p.alc; });
    var ok = pool.filter(function (p) { return p.av || (p.alc && country !== 'JP') || p.inq || euuk; });
    return ok.length ? ok : pool;
  }
  function stock(p) { return p.trk === false ? 999 : (p.q || 0); }
  /* 運勢の m（ice,light など）に似合う商品を選ぶ。合う物が無ければ無作為 */
  function matchProduct(pool, m) {
    if (!pool.length) return null;
    var want = String(m || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    if (!want.length) return pool[rand(pool.length)];
    var scored = pool.map(function (p) {
      var sv = String(p.sv || '').toLowerCase(), sc = 0;
      want.forEach(function (w) {
        if (w === 'nonalc' && !p.alc) sc += 3;
        if ((w === 'soda' || w === 'hot' || w === 'milk' || w === 'tea' || w === 'ice') && sv.indexOf(w) >= 0) sc += 2;
        if (w === 'share' && (sv.indexOf('soda') >= 0 || sv.indexOf('cocktail') >= 0)) sc += 1;
        if (w === 'sweet' && p.s >= 4) sc += 2;
        if (w === 'dry' && p.s <= 2) sc += 2;
        if (w === 'light' && p.b && p.b <= 2) sc += 2;
        if (w === 'rich' && p.b >= 4) sc += 2;
        if (w === 'aroma' && p.r >= 4) sc += 2;
        if (w === 'citrus' && p.a >= 4) sc += 2;
      });
      return { p: p, sc: sc };
    });
    /* 合う物（最高点から1点以内）の中で在庫の多い順。上位3つから無作為（毎日同じ一本にならないように） */
    var best = Math.max.apply(null, scored.map(function (x) { return x.sc; }));
    var top = scored.filter(function (x) { return x.sc >= best - 1; }).map(function (x) { return x.p; });
    top.sort(function (a, b) { return stock(b) - stock(a); });
    top = top.slice(0, 3);
    return top[rand(top.length)];
  }
  function rand(n) {
    if (window.crypto && crypto.getRandomValues) { var a = new Uint32Array(1); crypto.getRandomValues(a); return a[0] % n; }
    return Math.floor(Math.random() * n);
  }
  function pickCard() {
    var pool = cardPool();
    var x = rand(100), r = x < RATES.sr ? 'sr' : x < RATES.sr + RATES.r ? 'r' : 'n';
    var same = pool.filter(function (c) { return c.r === r; });
    if (!same.length) same = pool;
    return same[rand(same.length)];
  }

  function cover() {
    render(
      '<section class="w99g-cover">' +
        '<img class="w99g-cover__img" src="' + img(picAlcOk ? 'w99mq-cover.webp' : 'w99mq-alt-riding-kyuna-front.webp') + '" alt="' + esc(T.cover_alt) + '" width="1600" height="900">' +
        '<div class="w99g-cover__body">' +
          '<p class="w99g-eyebrow">' + esc(T.eyebrow) + '</p>' +
          '<h1>' + esc(T.title) + '</h1>' +
          '<p class="w99g-lead">' + esc(fmt(T.lead, { total: (picAlcOk ? CARDS : CARDS.filter(function (c) { return !c.alc; })).length })) + '</p>' +
          '<button type="button" class="w99g-btn w99g-btn--main" data-act="start">' + esc(T.start) + '</button>' +
          '<p class="w99g-small">' + esc(T.privacy) + '</p>' +
        '</div>' +
      '</section>'
    );
  }
  function gate() {
    if (!alcAllowed) { state.alc = false; machine(); return; }
    render('<section class="w99g-q"><h2>' + esc(T.gate_q) + '</h2><div class="w99g-opts">' +
      '<button type="button" class="w99g-opt" data-act="alc">' + esc(T.gate_alc) + '</button>' +
      '<button type="button" class="w99g-opt" data-act="na">' + esc(T.gate_na) + '</button></div></section>');
  }
  function ageCheck() {
    render('<section class="w99g-q"><h2>' + esc(fmt(T.age_q, { age: age })) + '</h2><div class="w99g-opts">' +
      '<button type="button" class="w99g-opt" data-act="adult">' + esc(T.yes) + '</button>' +
      '<button type="button" class="w99g-opt" data-act="minor">' + esc(T.no) + '</button></div>' +
      '<p class="w99g-small">' + esc(fmt(T.age_note, { age: age })) + '</p></section>');
  }
  /* お酒の道（日本）では、レア度・確率の表示を出さない（酒類業の自主基準Ⅱ2(2)「射幸心をあおる表現」を避ける。絵札の価値は無い） */
  function ratesLine() {
    /* クーポンを配る地域では「割引はありません」と書けないので、別の文（*_c）を使う */
    var npT = (couponEligible() && T.no_purchase_c) || T.no_purchase, rnT = (couponEligible() && T.rates_note_c) || T.rates_note;
    var np = npT ? '<p class="w99g-np">' + esc(npT) + '</p>' : '';
    if (state.alc) return np + '<p class="w99g-small">' + esc(rnT) + '</p>';
    return np + '<p class="w99g-rates">' + esc(fmt(T.rates, RATES)) + '</p><p class="w99g-small">' + esc(rnT) + '</p>';
  }
  function machine() {
    render(
      '<section class="w99g-machine">' +
        '<h2 class="w99g-vh">' + esc(T.title) + '</h2>' +
        '<div class="w99g-dome" aria-hidden="true">' +
          '<div class="w99g-balls">' + '<span class="w99g-ball w99g-ball--a"></span><span class="w99g-ball w99g-ball--b"></span><span class="w99g-ball w99g-ball--c"></span><span class="w99g-ball w99g-ball--d"></span><span class="w99g-ball w99g-ball--e"></span>' + '</div>' +
          '<img class="w99g-mascot" src="' + img((state.alc && picAlcOk) ? 'w99mq-kyuna-guide.webp' : 'w99mq-result-cola.webp') + '" alt="" width="200" height="200">' +
        '</div>' +
        '<div class="w99g-base"><div class="w99g-knob" aria-hidden="true"></div><div class="w99g-slot" aria-hidden="true"><span class="w99g-capsule" data-capsule></span></div></div>' +
        (pulledToday() ? '<p class="w99g-done">' + esc(T.done_today) + '</p>' : '<button type="button" class="w99g-btn w99g-btn--main w99g-pull" data-act="pull">' + esc(T.pull) + '</button>') +
        ratesLine() + collection() +
      '</section>'
    );
  }
  function pull(btn) {
    if (pulledToday()) { machine(); return; }
    btn.disabled = true; btn.textContent = T.pulling;
    var m = stage.querySelector('.w99g-machine'); if (m) m.classList.add('is-rolling');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var card = pickCard(), pool = productPool();
    /* お酒の道では「ノンアルコールを」と助言する運勢を出さない（商品が酒類になり矛盾するため・査読 P2-4） */
    var fl = (F && F.fortunes) ? F.fortunes.filter(function (x) { return !(state.alc && String(x.m || '').indexOf('nonalc') >= 0); }) : [];
    var fortune = fl.length ? fl[rand(fl.length)] : null;
    var prod = fortune ? matchProduct(pool, fortune.m) : (pool.length ? pool[rand(pool.length)] : null);
    setTimeout(function () { markPulled(); result(card, prod, false, fortune); }, reduce ? 200 : 1500);
  }
  function collection() {
    var col = loadCol(), pool = cardPool();
    var have = pool.filter(function (c) { return col[c.id]; }).length;
    var html = '<section class="w99g-col"><h3>' + esc(T.collection) + ' <span class="w99g-col__n">' + esc(fmt(T.collected, { n: have, total: pool.length })) + '</span></h3><ul class="w99g-col__list">';
    pool.forEach(function (c) {
      html += '<li class="w99g-col__item' + (state.alc ? '' : ' w99g-col__item--' + c.r) + (col[c.id] ? ' is-have' : '') + '">' +
        (col[c.id] ? '<img src="' + img(c.file) + '" alt="' + esc(T.cards[c.id] || c.id) + '" loading="lazy" width="120" height="120"><span>' + esc(T.cards[c.id] || c.id) + '</span>' : '<span class="w99g-col__unknown" aria-label="?">?</span>') +
        '</li>';
    });
    html += '</ul>';
    if (have) html += '<button type="button" class="w99g-link" data-act="reset">' + esc(T.reset) + '</button>';
    return html + '</section>';
  }

  /* 酒の格言（window.W99_QUOTES：{quotes:[{id,orig,lang,who,where,tr:{ja:..,en:..}}]}）。原語と読み手の言語の訳を並べる */
  function quoteBlock() {
    var Q = window.W99_QUOTES; if (!Q || !Q.quotes || !Q.quotes.length) return '';
    var qs = Q.quotes.filter(function (x) { return !(x.hide && x.hide.indexOf(lang) >= 0); }); if (!qs.length) return '';
    var q = qs[rand(qs.length)];
    var tr = (q.tr && (q.tr[lang] || q.tr[(lang || '').split('-')[0]] || q.tr.en)) || '';
    var who = (q.who && (q.who[lang] || q.who.en)) || '';
    var head = (Q.head && (Q.head[lang] || Q.head.en)) || '';
    return '<section class="w99-quote"><p class="w99-quote__head">' + esc(head) + '</p>' +
      '<p class="w99-quote__orig" lang="' + esc(q.lang) + '"' + (q.lang === 'ar' || q.lang === 'he' || q.lang === 'fa' ? ' dir="rtl"' : '') + '>' + esc(q.orig) + '</p>' +
      (tr && tr !== q.orig ? '<p class="w99-quote__tr">' + esc(tr) + '</p>' : '') +
      (who ? '<p class="w99-quote__who">— ' + esc(who) + '</p>' : '') + '</section>';
  }
  function fortuneBlock(f) {
    if (!f || !F) return '';
    return '<section class="w99g-fortune w99g-fortune--' + esc(f.g) + '"><p class="w99g-eyebrow">' + esc(F.fortune_head) + '</p>' +
      '<p class="w99g-fortune__grade">' + esc(F.grades[f.g] || f.g) + '</p><p class="w99g-fortune__text">' + esc(f.t) + '</p>' +
      '<p class="w99g-fortune__hint"><strong>' + esc(F.hint_label) + '</strong> ' + esc(f.h) + '</p></section>';
  }
  function result(card, prod, shared, fortune) {
    var col = loadCol(), isNew = !col[card.id];
    /* 共有された酒の絵札は、お酒の道と同じ扱い（レア度・確率を出さない。P1-2） */
    if (shared && card.alc) state.alc = true;
    var hideR = state.alc || card.alc;
    if (!shared) { col[card.id] = (col[card.id] || 0) + 1; saveCol(col); }
    var name = T.cards[card.id] || card.id;
    var url = location.origin + location.pathname + '?view=gacha&c=' + encodeURIComponent(card.id) + (fortune ? '&f=' + encodeURIComponent(fortune.id) : '');
    var html = '<section class="w99g-result">' + fortuneBlock(fortune) +
      '<div class="w99g-reveal' + (hideR ? '' : ' w99g-reveal--' + card.r) + '">' +
        '<p class="w99g-eyebrow">' + esc(T.card_head) + (hideR ? '' : ' <span class="w99g-rarity w99g-rarity--' + card.r + '">' + esc(T.rarity[card.r]) + '</span>') + '</p>' +
        '<img class="w99g-card" src="' + img(card.file) + '" alt="' + esc(name) + '" width="600" height="600">' +
        '<h2>' + esc(name) + '</h2>' +
        (shared ? '' : '<p class="w99g-new">' + esc(isNew ? T.new_card : T.dup_card) + '</p>') +
      '</div>';
    if (prod) {
      var inquiry = (prod.alc && country !== 'JP') || prod.inq || euuk;
      html += '<h3>' + esc(T.result_head) + '</h3><a class="w99g-prod" href="' + esc(prod.u) + '">' +
        (prod.img ? '<img src="' + esc(prod.img) + '" alt="" width="240" height="240" loading="lazy">' : '') +
        '<span class="w99g-prod__t">' + esc(prod.t) + '</span>' +
        '<span class="w99g-prod__p">' + (inquiry ? esc(T.inquiry_only) : esc(prod.pr)) + '</span>' +
        (prod.av || inquiry ? '' : '<span class="w99g-prod__s">' + esc(T.sold_out) + '</span>') + '</a>';
    } else if (!shared) {
      html += '<p>' + esc(T.none) + '</p>';
    }
    if (state.alc || (prod && prod.alc)) html += '<p class="w99g-notice">' + esc(alcNotice()) + '</p>';
    html += '<div class="w99g-actions">' + (shared ? '<button type="button" class="w99g-btn w99g-btn--main" data-act="again">' + esc(T.start) + '</button>' : '<p class="w99g-done">' + esc(T.done_today) + '</p>') +
      '<button type="button" class="w99g-btn w99g-btn--ghost" data-act="share" data-url="' + esc(url) + '">' + esc(T.share) + '</button></div>' +
      ratesLine() + '<p class="w99g-small">' + esc(T.disclaimer) + '</p>' + quoteBlock() + (shared ? '' : collection()) + '</section>';
    render(html);
    if (!shared) requestCoupon(stage.querySelector('.w99g-result .w99g-actions'));
  }

  stage.addEventListener('click', function (e) {
    var b = e.target.closest('[data-act]'); if (!b) return;
    var a = b.dataset.act;
    if (a === 'start') gate();
    else if (a === 'alc') ageCheck();
    else if (a === 'na' || a === 'minor') { state.alc = false; if (pendingShared) { pendingShared = null; cover(); } else machine(); }
    else if (a === 'adult') { state.alc = true; if (pendingShared) { var ps = pendingShared; pendingShared = null; result(ps.card, null, true, ps.f); } else machine(); }
    else if (a === 'pull') pull(b);
    else if (a === 'again') { state.alc = false; cover(); }
    else if (a === 'reset') { if (window.confirm(T.reset_confirm)) { try { localStorage.removeItem(STORE_KEY); } catch (e2) {} machine(); } }
    else if (a === 'copycode') { if (navigator.clipboard) { navigator.clipboard.writeText(b.dataset.code).then(function () { b.textContent = T.coupon_copied; }).catch(function () {}); } }
    else if (a === 'share') {
      var u = b.dataset.url;
      if (navigator.share) { navigator.share({ title: T.title, url: u }).catch(function () {}); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(u).then(function () { b.textContent = T.copied; }).catch(function () {}); }
    }
  });

  /* 共有された絵札（?c=）は、その札だけを見せる（商品は出さない・集めた札にも足さない） */
  var sharedId = new URLSearchParams(location.search).get('c');
  var sharedCard = sharedId && CARDS.filter(function (c) { return c.id === sharedId && (picAlcOk || !c.alc); })[0];
  var sharedF = null;
  try { var fid = new URLSearchParams(location.search).get('f'); if (fid && F && F.fortunes) sharedF = F.fortunes.filter(function (x) { return x.id === fid; })[0] || null; } catch (e) {}
  /* 酒の絵札（日本だけ）の共有は、年齢確認を通ってから見せる（査読 P1-2・P2-13） */
  var pendingShared = null;
  if (sharedCard && sharedCard.alc) { pendingShared = { card: sharedCard, f: sharedF }; ageCheck(); }
  else if (sharedCard) { state.alc = false; result(sharedCard, null, true, sharedF); }
  else { cover(); }
})();
